module.exports = __webpack_public_path__ + "static/img/number-copy.efe33d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_4/portrait/number-copy.png
// module id = 1oZk
// module chunks = 1